'use strict';

var clientSideValidation = require('../components/clientSideValidation');
var formValidation = require('../components/formValidation');
var addNewSchool = require('../addNewSchl');
var sessionTimeoutModal = require('../components/sessionTimeoutModal');

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

function getHomeUrl() {
    return window.location.origin + $('.logo-home').attr('href');
}

function populateCurrentYear() {
    $('.print-current-year').html(new Date().getFullYear());
}

function changeDialog(closeDialogID, openDialogID) {
    closeDialogID ? closeDialogID.modal("hide"): '';
    openDialogID.modal({ keyboard: false, backdrop: 'static' });
    $(openDialogID).on('shown.bs.modal', function (e) {
        $('body').addClass('modal-open');
    });
}

function loadCreateAccountShowData(url, noNeedOfNewModal) {
    const loader = $('#createAccountModal .modal-content');
    loader.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        success: function (data) {
            $('#createAccountModal .modal-content').empty().html(data);
            populateCurrentYear();
            clientSideValidation.addValidation();

            const submitCta = $('#createAccountShowSubmitCta');

            $('input[name="doYouTeachInSchool"]').on('change', function(e) {
                const createAccountNonEduMsg = $('#createAccountNonEduMsg');
                
                if ($(e.target).attr('id') === 'teachInSchoolYes') {
                    $('.createaccount-nextbtn-visibility').removeClass('d-none').addClass('d-flex');
                    $(submitCta).removeAttr('disabled');
                    $(createAccountNonEduMsg).addClass('d-none');
                } else {
                    $(submitCta).attr('disabled', 'disabled');
                    $(createAccountNonEduMsg).removeClass('d-none');
                    $('.createaccount-nextbtn-visibility').addClass('d-none').removeClass('d-flex');
                }
            });

            $(submitCta).on('click', function(e) {
                const createAccountEduShowUrl = $(this).data('href');
                showCreateAccountEduForm(e, createAccountEduShowUrl, loader);
            });

            noNeedOfNewModal ? $('#teachInSchoolYes').trigger('click') : '';
            loader.spinner().stop();
        },
        error: function() {
            loader.spinner().stop();
        }
    });
}

function showCreateAccountEduForm(e, url, loader) {
    e.preventDefault();
    loader.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        success: function (data) {
            $('#createAccountModal .modal-content').empty().html(data);
            clientSideValidation.addValidation();
            loader.spinner().stop();

            var form = '#createAccountModal', // Instead of form send modal id bcoz cta is outside of form
                submitCta = '#addSchoolBtn';

            $(form).find(".step-1").on("keyup focusout", "input", function() { 
                clientSideValidation.enableDisbaleButton(form, submitCta);
            });

            $(form).on("keyup focusout", "input.femail", function() { 
                var $elementForm = $(this).closest("form");
                if (($elementForm.find('.validateconfirmemail').val() !== "")) {
                    $elementForm.find('.validateconfirmemail').trigger("keyup", {which: 50});
                }
                clientSideValidation.enableDisbaleButton(form, submitCta);
            });
            
            $(form).on("keyup focusout", "input.fpassword", function() { 
                var $elementForm = $(this).closest("form");
                if (($elementForm.find('.validateconfirmpassword').val() !== "")) {
                    $elementForm.find('.validateconfirmpassword').trigger("keyup", {which: 50});
                }
                clientSideValidation.enableDisbaleButton(form, submitCta);
            });
        },
        error: function() {
            loader.spinner().stop();
        }
    });
}

function getCreateAccountFormData() {
    let grades = [];
    const selectedGrades = $('.account-grades-list input:checked');
    for (let i = 0; i < selectedGrades.length; i++) {
        if ($(selectedGrades[i]).data('isplusgrade')) {
            var gradeLevel = parseInt(selectedGrades[i].id);
            while(gradeLevel <= 12) {
                grades.push(gradeLevel);
                gradeLevel++;
            }
        } else {
            grades.push(selectedGrades[i].id);
        }
    };
    var schoolId = $('.addnewschool_selectedSchool_id').val();
    return $('#createAccountSubmitForm').serialize() + '&grades='+ grades.join(',') + '&schoolId='+schoolId;
}

function passwordResetFormSubmit(e, form, loader) {
    e.preventDefault();
    loader.spinner().start();
    const url = $(form).attr('action');
    $.ajax({
        url: url,
        type: 'post',
        data: form.serialize(),
        success: function (data) {
            $('#passwordResetModal .modal-content').empty().html(data);
            window.location.href = getHomeUrl();
        },
        error: function() {
            window.location.href = getHomeUrl();
        }
    });
}

module.exports = {
    login: function () {
        $(document).on('submit', 'form.login', function (e) {
            var form = $(this);
            var loader = form.parents('.modal-content');
            e.preventDefault();
            var url = form.attr('action');
            loader.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    loader.spinner().stop();
                    if (!data.success) {
                        //formValidation(form, data);
                        clientSideValidation.addValidation();
                        if (data.status === 'ERROR_NONEDU_LOGIN') {
                            $('.login-noneduattempt-section').removeClass('d-none');
                            $('.login-section').addClass('d-none');
                        } else {
                            $('form.login').trigger('login:error', data);
                            // show error msg
                            $('.login-error').html(data.error).removeClass('d-none');
                        }
                    } else {
                        $('form.login').trigger('login:success', data);
                        if (window.location.href.indexOf("activationToken") > 1) {
                            window.location.href = getHomeUrl();
                        } else {
                            location.reload();
                        }
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        loader.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $(document).on('submit', '.reset-password-form', function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');
            var loader = form.parents('.modal-content');
            loader.spinner().start();
            
            $.ajax({
                url: url,
                type: 'post',
                data: form.serialize(),
                success: function (data) {
                    loader.spinner().stop();
                    $('#requestPasswordResetModal .modal-content').empty().html(data);
                },
                error: function () {
                    loader.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    roleChangeHandle: function() {
        $(document).on('change', '#userRole', function() {
            if ($(this).val() === 'SBS') {
                $('.subrole-container').removeClass('d-none');
            } else {
                $('.subrole-container').addClass('d-none');
                $('.userSubRole option').removeAttr('selected');
            }
        });

        $(document).on('change', '#userRole, #userSubRole, .account-grades-list input', function() {
            var form = '#createAccountModal', // Instead of form send modal id bcoz cta is outside of form
                submitCta = $(form).find('.next-step:visible');

            if ($('.account-page').length) {
                form = '#dwfrm_profile_changeschoolrole',
                submitCta = $(form).find('.btn-accountform-submit');
            }
            clientSideValidation.enableDisbaleButton(form, submitCta);
        });
    },

    selectUnselectAllGrades: function() {
        $('body').on('click', '#selectAllGrades, .no-preference, .account-grades-list .custom-checkbox:not(.no-preference)', function() {
            var form = '#createAccountModal', // Instead of form send modal id bcoz cta is outside of form
                submitCta = $(form).find('.next-step:visible');

            const $this = $(this), 
                $allGrades = $('.account-grades-list input[type="checkbox"]:not(#NP)'),
                $nopreference = $('.no-preference input');

            if ($('.account-page').length) {
                form = '#dwfrm_profile_changeschoolrole',
                submitCta = $(form).find('.btn-accountform-submit');
            }

            if($this.is('#selectAllGrades')) {
                $allGrades.prop('checked', true);
                $nopreference.prop('checked', false);
            } else if($this.hasClass('no-preference')) {
                $allGrades.prop('checked', false);
            } else {
                $nopreference.prop('checked', false);
            }

            clientSideValidation.enableDisbaleButton(form, submitCta);
        });
    },

    showHidePassword: function() {
        $('body').on('click', '.showhide-password', function() {
            $(this).find('svg').toggleClass("fa-eye fa-eye-slash");
            const input = $("#login-form-password");
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
    },

    handleModalStepsClickEvent: function() {
        $('body').on('click', '.currentstep span.active', function() {
            var clickedStep = $(this).data('step'),
                stepBack =  $('.multiplesteps:not(".d-none")').find('.back-step').data('stepback');
            if ( clickedStep > stepBack) {
                return; // don't do anything if clicked on current step
            } else if ( clickedStep === stepBack) { // if click on immediate back one
                $('.multiplesteps.step-' + (stepBack+1)).find('.back-step').trigger('click');
            } else { // if click any other instead of immediate back one
                $('.multiplesteps.step-' + (clickedStep + 1)).find('.back-step').trigger('click');
            }
        });
    },

    handleBackStep: function() {
        $('body').on('click', '.back-step', function() {
            const stepBackNo = $(this).data('stepback');
            const form = $('#createAccountSubmitForm');
            $('.multiplesteps').addClass('d-none');
            $('.multiplesteps.step-' + stepBackNo).removeClass('d-none');

            $('.currentstep span').each(function() {
                if ($(this).data('step') > stepBackNo) {
                    $(this).removeClass('active').removeAttr('tabindex');
                } else if ($(this).data('step') === stepBackNo) {
                    $(this).removeAttr('tabindex');
                }
            });

            if (stepBackNo === 1) {
                if (formValidation.checkFormValid(form)) {
                    $('.next-step:visible').removeAttr("disabled");
                }
                // Reset School Modal
                const schoolCodeInput = $('.multiplesteps.step-2 .is-invalid');
                //$('.multiplesteps:visible .is-invalid').removeClass('is-invalid');
                $(schoolCodeInput).val('').removeClass('is-invalid').attr('aria-invalid', false);
                $(schoolCodeInput).siblings('.is-invalid').remove();
                $('.search-addnewschool').attr('disabled','disabled');
                $('.schoolcity-list-result').addClass('d-none');
            }
        });
    },

    handleNextStep: function() {
        $('body').on('click', '.next-step', function() {
            const $self = $(this);
            const stepNextNo = $self.data('stepnext');
            const form = $('#createAccountSubmitForm');
            const loader = $('#createAccountModal .modal-content');

            if (stepNextNo) {
                if ((stepNextNo === 2 || stepNextNo === 6) && !formValidation.checkFormValid(form)) return;

                let isEmailValid = true;
                if (stepNextNo === 2) {
                    // Email Check then proceed or return
                    const emailCheckUrl = $self.data('href');
                    loader.spinner().start();
                    $.ajax({
                        url: emailCheckUrl,
                        data: {'email': $(form).find('.femail').val()},
                        async: false,
                        type: 'post',
                        success: function (data) {
                            const emailErrorMsg = $('.emailErrorMsg');
                            if (data.status === 'error') {
                                isEmailValid = false;
                                $(emailErrorMsg).html($self.data(data.accountStatus).replace('customernoplaceholder', data.customerNo)).removeClass('d-none');
                            } else {
                                $(emailErrorMsg).addClass('d-none');
                            }
                            loader.spinner().stop();
                        },
                        error: function() {
                            loader.spinner().stop();
                        }
                    });

                    if (!isEmailValid) {
                        return;
                    }

                    addNewSchool.init();
                }

                $('.multiplesteps').addClass('d-none');
                $('.multiplesteps.step-' + stepNextNo).removeClass('d-none');

                $('.step' + stepNextNo + '-indicator').addClass('active');

                $(document).on('change', '.pref-option input, #readPrivacyTerms', function() {
                    var keepDisable = true;
                    const $button = $('.next-step:visible');
                    if ($('input[name="dwfrm_profile_customer_language"]:checked').length && $('input[name="dwfrm_profile_customer_addtoemaillist"]:checked').length && $('#readPrivacyTerms:checked').length) {
                        keepDisable = false;
                    }
                    if (keepDisable) {
                        $button.attr("disabled","disabled");
                    } else {
                        $button.removeAttr("disabled");
                    }
                });
            } else {
                // Submit Ajax
                const url = $(form).attr('action');
                loader.spinner().start();
                $.ajax({
                    url: url,
                    data: getCreateAccountFormData(),
                    type: 'post',
                    success: function (data) {
                        if (data.status === 'error') {
                            // Error TODO:Nitesh
                        } else {
                            $('#createAccountModal .modal-content').empty().html(data.html);
                        }
                        
                        loader.spinner().stop();
                    },
                    error: function(data) {
                        loader.spinner().stop();
                    }
                });
            }
        });
    },

    activationMailResend: function() {
        var resendEmailCounter = 0;
        $('body').on('click', '#accountActivationSubmitCta', function(e) {
            e.preventDefault();
            
            const loader = $('#activationModal .modal-content');
            loader.spinner().start();

            const url = $(this).data('href');
            $.ajax({
                url: url,
                type: 'post',
                data: $('#accountActivationSubmitForm').serialize(),
                success: function (data) {
                    resendEmailCounter = resendEmailCounter + 1;
                    $('#activationModal .modal-content').empty().html(data);
                    if (resendEmailCounter >= 3) {
                        $("#accountActivationSubmitCta").remove();
                    }
                    loader.spinner().stop();
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });
    },

    requestPasswordMailResend: function() {
        var requestPasswordMailCounter = 0;
        $('body').on('click', '#resetPasswordSendEmailCta', function(e) {
            e.preventDefault();
            var modal = $('#requestPasswordResetModal');
            if ($('#createAccountModal:visible').length) {
                modal = $('#createAccountModal');
            } else if ($('#signInModal:visible').length) {
                modal = $('#signInModal'); 
            }

            const loader = $(modal).find('.modal-content');
            loader.spinner().start();

            const url = $(this).data('href');
            $.ajax({
                url: url,
                type: 'post',
                data: {'customerNo': $('#passwordResetCustomerNo').val()},
                success: function (data) {
                    requestPasswordMailCounter = requestPasswordMailCounter + 1;
                    $(modal).find('.modal-content').empty().html(data);
                    if (requestPasswordMailCounter >= 3) {
                        $("#resetPasswordSendEmailCta").remove();
                    }
                    loader.spinner().stop();
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });
    },

    setRequestPasswordCustomerNo: function() {
        // Set Customer Number for Email
        $(document).on('click', '.reset-password-radio', function() {
            const customerNumber = $(this).val();
            $('#passwordResetCustomerNo').val(customerNumber);
            $('#resetPasswordSendEmailCta').removeAttr('disabled');
        });
    },

    requestPasswordResetModalOpen: function() {
        $('body').on('click', '#password-reset', function() {
            $('body').trigger('requestPasswordResetModal:open');
        });
    },

    init: function() {
        populateCurrentYear();
        
        // Open Signin Modal
        $('body').on('click', '.signModal', function(e) {
            e.preventDefault();
            const url = $(this).data('href');
            $('body').trigger('signinModal:open', url);
        });

        $('body').on('signinModal:open', function (e, url, wishlistProductId, loginAfterTimeOut) {
            const closeDialog = $('.modal.show').length ? $('#' + $('.modal.show').attr('id')) : '';
            changeDialog(closeDialog, $('#signInModal'));

            if (wishlistProductId && wishlistProductId !== 'undefined') {
                url = url + '?wishlistProductId=' + wishlistProductId;
            }
            const loader = $('#signInModal .modal-content');
            var loginShowData = {};
			if (window.location.href.indexOf("activationToken") > 1) {
                loginShowData.activationToken = new URLSearchParams(window.location.search).get('activationToken');
            }
            loader.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                data: loginShowData,
                success: function (data) {
                    $('#signInModal .modal-body').empty().html(data);
                    if (loginAfterTimeOut) {
                        $('.session-timeout-signin-description').removeClass('d-none');
                    }

                    $('#signInModal .close').on('click', function(e) {
                        e.preventDefault();
                        loginAfterTimeOut ? window.location.reload() : $('#signInModal').modal('hide');
                    });

                    loader.spinner().stop();
                    populateCurrentYear();
                    clientSideValidation.addValidation();

                    $('#loginForm').on("keyup focusout", "input", function() {
                        clientSideValidation.enableDisbaleButton('#loginForm', '#loginFormSubmitCta');
                    });

                    // Remember Me
                    const rememberMe = getCookie("rememberMe");
                    if (rememberMe) {
                        const emailElem = $('#login-form-email');
                        if (emailElem.length > 0) {
                            emailElem[0].value = rememberMe;
                        }
                        const rememberMeElem = $('#rememberMe');
                        if (rememberMeElem.length > 0) {
                            rememberMeElem[0].checked = true;
                        }
                    }
                },
                error: function() {
                    if (window.location.href.indexOf("activationToken") > 1) {
                        window.location.href = getHomeUrl();
                    }
                    loader.spinner().stop();
                }
            });
        });

        $('body').on('click', '.activationModal', function(e) {
            e.preventDefault();
            const url = $(this).data('href');
            $('body').trigger('activationModal:open', url);
        });

        $('body').on('activationModal:open', function (e, url) {
            const closeDialog = $('.modal.show').length ? $('#' + $('.modal.show').attr('id')) : '';
            changeDialog(closeDialog, $('#activationModal'));

            $('#activationModal .modal-body').empty();

            var emailID = '';
 
            if ($('#createAccountModal').is(':visible')) {
                emailID = $('#createAccountModal #email').val();
            } else {
                emailID = $('#signInModal #login-form-email').val();
            }

            const loader = $('#activationModal .modal-content');
            loader.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                data: {email: emailID},
                success: function (data) {
                    $('#activationModal .modal-content').empty().html(data);
                    
                    loader.spinner().stop();
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });

        $('body').on('requestPasswordResetModal:open', function (e) {
            const newModal = $('#requestPasswordResetModal');
            changeDialog($("#signInModal"), newModal);

            $(newModal).find('.modal-body').empty();

            const loader = $(newModal).find('.modal-content');
            loader.spinner().start();

            $.ajax({
                url: $(newModal).data('href'),
                type: 'get',
                success: function (data) {
                    $(newModal).find('.modal-content').empty().html(data);
                    
                    loader.spinner().stop();
                    clientSideValidation.addValidation();

                    $('#requestPasswordResetForm').on("keyup focusout", "input", function() {
                        clientSideValidation.enableDisbaleButton('#requestPasswordResetForm', '#submitEmailButton');
                    });
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });

        $('body').on('passwordResetModal:open', function (e) {
            const newModal = $('#passwordResetModal');
            const closeDialog = $('.modal.show').length ? $('#' + $('.modal.show').attr('id')) : '';
            changeDialog(closeDialog, newModal);

            $(newModal).find('.modal-body').empty();

            const loader = $(newModal).find('.modal-content');
            loader.spinner().start();

            var loginShowData = {};
            if (window.location.href.indexOf("resetPasswordToken") > 1) {
                loginShowData.resetPasswordToken = new URLSearchParams(window.location.search).get('resetPasswordToken');
            }
            $.ajax({
                url: $(newModal).data('href'),
                type: 'get',
                data: loginShowData,
                success: function (data) {
                    $(newModal).find('.modal-body').html(data);
                    
                    loader.spinner().stop();
                    clientSideValidation.addValidation();

                    const passwordresetsubmitform = $('#passwordResetSubmitForm');
                    const submitCta = $('#passwordResetSubmitCta');

                    $(passwordresetsubmitform).on("keyup focusout", "input", function() {
                        clientSideValidation.enableDisbaleButton(passwordresetsubmitform, submitCta);
                    });

                    $(passwordresetsubmitform).on("keyup focusout", "input.fpassword", function() { 
                        var $elementForm = $(this).closest("form");
                        if (($elementForm.find('.validateconfirmpassword').val() !== "")) {
                            $elementForm.find('.validateconfirmpassword').trigger("keyup", {which: 50});
                        }
                        clientSideValidation.enableDisbaleButton(passwordresetsubmitform, submitCta);
                    });
                    
                    $(submitCta).on('click', function(e) {
                        passwordResetFormSubmit(e, passwordresetsubmitform, loader);
                    });
                },
                error: function() {
                    window.location.href = getHomeUrl();
                }
            });
        });

        $('body').on('click', '.createAccount', function(e) {
            e.preventDefault();
            const createAccountShowUrl = $(this).data('href');
            const noNeedOfNewModal = $(this).hasClass('noNeedOfNewModal');
            $('#createAccountModal .modal-body').empty();
            if (noNeedOfNewModal) {
                loadCreateAccountShowData(createAccountShowUrl, noNeedOfNewModal);
            } else {
                $('body').trigger('createAccountModal:open', createAccountShowUrl);
            }
        });

        $('body').on('createAccountModal:open', function (e, url) {
            if ($('.login-section.d-none').length) {
                $('.login-noneduattempt-section, .login-error').addClass('d-none');
            }
            changeDialog($("#signInModal"), $('#createAccountModal'));
            loadCreateAccountShowData(url);
        });

        $('body').on('missingPrefModal:open', function (e) {
            $("#missingPrefModal").modal({keyboard: false, backdrop: 'static'}); // open the modal
            populateCurrentYear();
            $("#missingPrefModal #missingpref-accordion").html($('.missingPrefData').html());
            $('#updatePredModalGoToProfile').data('step', $('.get-gotostep').data('gotostep'));
            $('.missingPrefData').remove('');

            // Enable Disable Go to Profile CTA
            $('#consentPrivacyTerms').on('change', function () {
                const updatePredModalGoToProfile = $('#updatePredModalGoToProfile');
                if ($(this).is(':checked')) {
                    $(updatePredModalGoToProfile).removeAttr('disabled');
                } else {
                    $(updatePredModalGoToProfile).attr('disabled', 'disabled');
                }
            });

            // Redirect to Accoung Page
            $('#updatePredModalGoToProfile').on('click', function() {
                let savedStep = $(this).data('step');
                let gotostep = '';
                if (savedStep) {
                    if (savedStep === 'PI') {
                        gotostep = 'profile';
                    } else if (savedStep === 'SR') {
                        gotostep = 'schoolrole';
                    } else {
                        gotostep = 'pref';
                    }
                }
                window.location.href = $(this).data('href') + (gotostep ? ('?step=' + gotostep) : '');
            });
        });

        // Show Login Screen
        $(document).on('click', '.backToLogin', function() {
            $('.login-noneduattempt-section, .login-error').addClass('d-none');
            $('.login-section').removeClass('d-none');
        });

        // Open the Missing Pref Modal except Account Page
        if ($('.showMissingPrefModal').val() === 'true' && !$('.account-page').length) {
            $('body').trigger('missingPrefModal:open');
        }

        sessionTimeoutModal();

        if (localStorage.getItem('openSessionSignInModal')) {
            $('body').trigger('signinModal:open', [$("#sessionTimeoutModal").data('login'), null, true]);
            localStorage.removeItem('openSessionSignInModal');
        }
    },

    activationModalOpen: function() {
        if (window.location.href.indexOf("activationToken") > 1) {
            $('.signModal:first').trigger('click');
    	}
    },

    resetPasswordModalOpen: function() {
        if (window.location.href.indexOf("resetPasswordToken") > 1) {
            $('body').trigger('passwordResetModal:open');
    	}
    },

    redirectToHome: function() {
        $('body').on('click', '.redirecttohome', function(e) {
            window.location.href = getHomeUrl();
        });
    }
};
